export const EMPTY_VALUE = "—";
import type { SectionId } from "./types";

export const sidebarItems = (): {
  id: SectionId;
  title: string;
  hasAlert: boolean;
}[] => [
  { id: "summary", title: "Summary", hasAlert: false },
  { id: "plans", title: "Plans & Credits", hasAlert: false },
  {
    id: "billing",
    title: "Billing",
    hasAlert: false,
  },
  { id: "schedule", title: "Schedule", hasAlert: false },
  {
    id: "communication",
    title: "Communication",
    hasAlert: false,
  },
  {
    id: "personal-info",
    title: "Personal Information",
    hasAlert: false,
  },
  { id: "notes", title: "Notes", hasAlert: false },
  {
    id: "documents",
    title: "Documents",
    hasAlert: false,
  },
  { id: "settings", title: "Settings", hasAlert: false },
];

export const GENDER_OPTIONS = [
  { label: "Female", value: "F" },
  { label: "Male", value: "M" },
  { label: "Not specified", value: "OTHER" },
];

export enum ReferredByOptionId {
  Unassigned = "0",
  Google = "1",
  Facebook = "2",
  Advertisement = "3",
  ExistingMember = "4",
  Other = "5",
  WebsiteBlog = "6",
  WalkIn = "7",
  StaffMember = "8",
}

/**
 * These are stored in referral_sources in DB.
 * Hardcoding on the frontend as they seem static.
 */
export const REFERRED_BY_OPTIONS = () => [
  { label: "Walk In", optionId: ReferredByOptionId.WalkIn },
  { label: "Google", optionId: ReferredByOptionId.Google },
  { label: "Facebook", optionId: ReferredByOptionId.Facebook },
  { label: "Advertisement", optionId: ReferredByOptionId.Advertisement }, // will show other input field
  { label: "Website / Blog", optionId: ReferredByOptionId.WebsiteBlog },
  { label: "Staff Member", optionId: ReferredByOptionId.StaffMember }, // will show staff select field
  { label: "Existing Member", optionId: ReferredByOptionId.ExistingMember }, // will show member select field
  { label: "Other", optionId: ReferredByOptionId.Other }, // will show other input field
  { label: "Unassigned", optionId: ReferredByOptionId.Unassigned },
];

export const PAGINATION_PAGE_SIZE = 5;
